/* eslint-disable no-console */
import { useHistory } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import { Button } from '../../components/button'
import { Progress } from './style'
import noImage from '../../assets/img/no-image.png'
import FormState from '../../model/FormState'
import { storage } from '../../base'

export default function FormStep4(
    props: {setTab: any, formState: FormState, set: any, handleSubmit: Function}
) {
    const {
        setTab, formState, set, handleSubmit
    } = props
    const history = useHistory()
    const form = useRef<HTMLFormElement>(null)
    const [img, setImg] = useState<string>()
    const [visible, setVisible] = useState<boolean>(false)
    const [errorMsg, setErrorMsg] = useState('')
    const [progress, setProgress] = useState(0)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (formState.image) {
            readFile(formState.image)
        }
    }, [])

    const isValidFile = (file: File): boolean => {
        const type = file.type.split('/')[1]
        return type === 'png' || type === 'jpeg'
    }

    const isValidSize = (file: File): boolean => {
        return file.size * 0.00097656 < 2048
    }

    const handleChange = (e: any) => {
        setProgress(0)
        const file = e.target.files[0]
        if (file) {
            if (!isValidFile(file)) {
                setImg('')
                set('setImagem', undefined)
                setErrorMsg('Selecione uma imagem no formato jpeg ou png')
                setVisible(true)
            } else if (!isValidSize(file)) {
                setImg('')
                set('setImagem', undefined)
                setErrorMsg('Selecione uma imagem com no máximo 2MB')
                setVisible(true)
            } else {
                setImage(file)
                setVisible(false)
            }
        }
    }

    const setImage = (file: File) => {
        set('setImagem', file)
        readFile(file)
    }

    const readFile = (file: File) => {
        const blob = file as Blob
        const reader = new FileReader()
        reader.onload = () => {
            setImg(reader.result as string)
        }
        reader.readAsDataURL(blob)
    }

    const handleUpload = (file: File) => {
        setLoading(true)
        const tempRef = ref(
            storage, `images/${formState.nome}/${file.name}`
        )
        const blob = file as Blob
        const task = uploadBytesResumable(tempRef, blob)
        task.on(
            'state_changed',
            (snapshot) => {
                const currentProgress = Math.round((snapshot.bytesTransferred
                    / snapshot.totalBytes) * 80)
                setProgress(currentProgress)
            },
            (error) => {
                console.log(error)
            },
            () => {
                getDownloadURL(tempRef).then((url) => {
                    set('setLogo', url)
                    setProgress(100)
                    handleSubmit()
                })
            }
        )
    }

    const validator = (): boolean => {
        if (!formState.image && !formState.logo) {
            setErrorMsg('Você precisa selecionar uma imagem')
            setVisible(true)
            return false
        }
        form.current?.classList.add('was-validated')
        return true
    }

    const onSubmit = (e: any) => {
        e.preventDefault()
        const valid = validator()
        if (valid) {
            if (formState.image) {
                handleUpload(formState.image)
            } else {
                handleSubmit()
            }
        }
    }

    const voltar = () => {
        setTab(3)
    }

    const cancelar = () => {
        history.push('/buscar')
    }

    const getImage = () => {
        if (img) return img
        return formState.logo
    }

    return (
        <form noValidate onSubmit={onSubmit} ref={form}>
            <div className="form-row">
                <div className="col-md-6 mb-3">
                    <label htmlFor="formImg" className="fileLabel">
                        <p>Escolha uma imagem</p>
                        <span className="btn">Selecione</span>
                    </label>
                    <p className="imgLink">
                        {formState.image ? formState.image.name
                            : 'Nenhuma imagem selecionada'}
                    </p>
                    <input
                        type="file"
                        className="form-control-file"
                        id="formImg"
                        onChange={handleChange}
                        required
                    />
                    <div className={`validator
                        ${visible ? 'visible' : ''}`}
                    >
                        {errorMsg}
                    </div>
                </div>
                <div className="col-md-6 mb-3">
                    <div className="img-container">
                        <img src={getImage() || noImage} alt="Imagem" />
                    </div>
                    {
                        loading ? (
                            <Progress>
                                <div style={{ width: `${progress}%` }} />
                            </Progress>
                        ) : false
                    }
                </div>
            </div>
            <div className="form-row justify-content-end mt-2">
                <button type="button" onClick={cancelar} className="btn mr-2">
                    Cancelar
                </button>
                <button type="button" onClick={voltar} className="btn mr-2">
                    Voltar
                </button>
                <Button type="submit" className="ml-2">
                    Finalizar
                    <i className="fas fa-check fa-sm ml-2" />
                </Button>
            </div>
        </form>
    )
}
